import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";

/** Site-wide closing block above the footer: keep learning. */
export default function FooterCTA() {
  return (
    <section className="bg-background py-16 lg:py-20" aria-labelledby="footer-cta-heading">
      <div className="container">
        <div className="mx-auto max-w-3xl rounded-[22px] border border-border bg-card p-8 text-center shadow-[0_20px_50px_rgba(0,0,0,0.12)] md:p-12">
          <p className="text-xs font-extrabold uppercase tracking-[0.2em] text-primary">Independent Trailer Education</p>
          <h2 id="footer-cta-heading" className="mt-3 font-display text-3xl font-black uppercase leading-tight text-foreground md:text-4xl">
            Learn Before You Haul
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-7 text-muted-foreground">
            Weight ratings, towing rules, maintenance and ownership costs, explained in plain language from real industry experience.
          </p>
          <div className="mt-7 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
            <Link
              to="/trailer-guides"
              className="inline-flex items-center justify-center gap-2 rounded-[22px] bg-primary px-7 py-4 font-display text-sm font-black uppercase tracking-wide text-primary-foreground shadow-[0_20px_50px_rgba(0,0,0,0.12)] transition hover:-translate-y-0.5"
            >
              <BookOpen className="h-4 w-4" /> Explore Trailer Guides <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/blog"
              className="inline-flex items-center justify-center gap-2 rounded-[22px] border-2 border-border bg-card px-7 py-4 font-display text-sm font-black uppercase tracking-wide text-foreground transition hover:-translate-y-0.5 hover:border-primary"
            >
              Read the Latest Articles
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
